import {MultiselectConfig} from '../../../components/multiselect';
import {QueryLangFilterOperator} from '../../../enums/query-lang-filter-operator';
import {QueryLangFilterCriterionMultiselect} from '../../../models/filters/query-lang-filter-criterion-multiselect';
import {TX_HISTORY_REC_STATUS_SELECT_ITEMS} from '../tx-history-rec';

export class FilterTxByMultiStatus extends QueryLangFilterCriterionMultiselect {
    public override name: string = 'filter-tx-by-status';
    public override query: string[] = [];
    public override fieldNames: string[] = ['transaction.status', 'order.status'];
    public override operator: QueryLangFilterOperator = QueryLangFilterOperator.IN;

    public override multiselectConfig: MultiselectConfig = {
        menuItems: TX_HISTORY_REC_STATUS_SELECT_ITEMS,
        label:     'components.filters.status'
    };

    public override getPrimitiveQueryValue(): string {
        return this.query ? this.query.join(',') : '';
    }

}
